import { SystemAuthorizations } from 'shell/authorizations/system';
import * as yup from 'yup';
import { HeadCell } from 'shell/components/shared/table/types';
import { Profile } from './types';
import { regexOnlyNumber, alphanumericRegex } from 'shell/constants/regex';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.ProfiloQuery],
  create: [SystemAuthorizations.ProfiloAdd],
  edit: [SystemAuthorizations.ProfiloUpdate],
  delete: [SystemAuthorizations.ProfiloDelete],
});

export const validationSchemaProfilesFilter = yup.object({
  id: yup.string().nullable().notRequired().matches(regexOnlyNumber, 'Il campo è numerico'),
  description: yup
    .string()
    .nullable()
    .notRequired()
    .matches(alphanumericRegex, 'Il campo è alfanumerico'),
});

export const headCells: HeadCell<Profile, keyof Profile>[] = [
  {
    id: 'id',
    label: 'Codice',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'action',
    label: '',
  },
];
